import request from '@/helpers/request'
import store from '@/store/index'
import snack from '@/helpers/snack'
import Vue from 'vue'

export default {
  ADD_FINGER_PRINT({ commit, state, rootState }, params) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.post}`,
      {
        params: {
          employer_id: rootState.employers.employer.id,
          title: params.title,
          fingerprint: _.replace(params.finger, '\n', ''),
          creator_id: rootState.user.id,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        store.dispatch('GET_FINGER_PRINT_FOR_EMPLOYER', rootState.employers.employer.id)
      } else {
        throw response
      }
    })
  },
  GET_FINGER_PRINT_FOR_EMPLOYER({ commit, state }, id, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.get.replace('$id', id)}`,
      {
        params: {},
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data.items
        commit('setFingerPrintsForEmployers', data)
      } else {
        throw response
      }
    })
  },
  DELETE_FINGER_PRINT_FOR_EMPLOYER({ commit, state }, params) {
    return request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.delete
        .replace('$finger_id', params.finger_id)
        .replace('$employer_id', params.employer_id)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        store.dispatch('GET_FINGER_PRINT_FOR_EMPLOYER', params.employer_id)
      } else {
        throw response
      }
    })
  },
  CHECK_IN_EMPLOYER({ commit, state }, params) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.postCheckIn}`,
      {
        params: {
          employer_id: params.employer_id,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        return response
      } else {
        throw response
      }
    })
  },
  CREATE_CHECK_IN({ commit, state }, params) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.creteCheckIn}`,
      {
        params: {
          employer_id: params.employer_id,
          come_at: params.come_at,
          gone_at: params.gone_at,
        },
      },
      true,
    ).then(response => {
      snack.add('Успешно сохраненно', 'primary')
      return response
    })
  },
  GET_LIST_ACTIVE_FINGERPRINT({ commit, state }, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.postCheckIn}`,
      {
        params: {
          with: 'employer',
          orderBy: 'updated_at',
          sortedBy: 'desc',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data.items
        commit('setLoad', false)
        commit('setActiveListFingerprint', data)
      } else {
        throw response
      }
    })
  },
  PUT_FINGERPRINT_CHECKIN({ commit, state }, params) {
    return request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.fingerPrints.putCheckIn.replace('$id', params.id)}`,
      {
        params: {
          come_at: params.come_at,
          gone_at: params.gone_at,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        snack.add('Успешно сохраненно', 'primary')
      } else {
        throw response
      }
    })
  },
}
